<template>
    <div>
        <!-- 合同发票记录 -->
        <basic-container>
        <el-form inline label-width="80px" size="small">

                <el-form-item label="项目名称">
                    <el-select
                    v-model="query.projectId"
                    placeholder="请选择项目名称"
                    @change="projectChange"
                    style="width: 100%"
                    >
                    <el-option
                        v-for="(item, index) in projectList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="合同编号">
                    <el-input clearable style="width: 100%"  placeholder="请输入合同编号" v-model="query.code" maxlength="50"
                        show-word-limit />
                </el-form-item>

                <el-form-item label="发票日期">
                    <el-date-picker
                    clearable
                    style="width: 100%"
                    v-model="query.timeRange"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>


                    <el-form-item label="发票类型">
                        <el-select
                        v-model="query.type"
                        placeholder="请选择发票类型"
                        clearable
                        style="width: 100%"

                        >
                        <el-option
                            v-for="(item, index) in invoiceTypeList"
                            :key="index"
                            :label="item.dictValue"
                            :value="item.dictKey"
                        ></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="发票号码">
                         <el-input placeholder="请输入发票号码" style="width: 100%" v-model="query.invoiceNo " maxlength="50"
                        show-word-limit clearable />
                    </el-form-item>

                <el-form-item label="发票金额">
                    <div style="display:flex;">
                        <el-input  placeholder="请输入发票金额" v-model="query.payAmountStart " maxlength="12" clearable/>-
                            <el-input  placeholder="请输入发票金额" v-model="query.payAmountEnd " maxlength="12" clearable />
                    </div>

                </el-form-item>

                <el-form-item label-width="100px" label="供应商名称">
                    <el-input placeholder="请输入供应商名称" clearable style="width: 100%" v-model="query.partnerName " maxlength="50"
                        show-word-limit />
                </el-form-item>

                <div class="btnArea" >
                    <el-button type="primary" @click="searchInvoiceRecordsList" size="small"> 搜索 </el-button>
                    <el-button @click="searchClear" size="small"> 清空 </el-button>
                </div>

        </el-form>
        <avue-crud
            :option="option"
            :table-loading="loading"
            :data="invoiceRecordsList"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @search-reset="searchReset"
            @selection-change="selectionChange"
            @refresh-change="onLoad">

            <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addConstractInvoice"> 新 增</el-button>
            <!-- <el-button type="primary" @click="delConstractInvoice">删除</el-button> -->
            </template>
            <template slot-scope="scope" slot="menu">
            <el-button
                type="text"
                size="small"
                icon="el-icon-tickets"
                @click="checkInvoiceRecord(scope.row)"
                >查看
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="editInvoiceRecord(scope.row)"
                >编辑
            </el-button>
            <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                v-if='scope.row.lifecycleIndex!=3&&scope.row.lifecycleIndex!=5'
                @click="removeInvoiceRecord(scope.row.id)"
                >删除
            </el-button>
            </template>
            <template slot-scope="scope" slot="amount" >
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.amount)  }}</span></div>
            </template>
        </avue-crud>
        <el-dialog
          :title="dialogTitle"
          :visible.sync="addOrEditOrWatchFlag"
          v-if="addOrEditOrWatchFlag"
          width="60%"
          append-to-body="true"
          :before-close="handleClose"
          :close-on-click-modal="false">
          <invoiceDetail :invoiceForm='invoiceRecordDetail'  @close='dialogClose' :projectId='query.projectId' :operateStatus='operateStatus' @getInvoiceDetail='getInvoiceDetail'></invoiceDetail>

        </el-dialog>

        </basic-container>
    </div>
</template>

<script>
  import {paymentrecordImg
} from '@/api/crmedical/contract/execution';
import { getProjectList } from '@/api/crmedical/project/project';
import {
  getDictData,

} from '@/api/crmedical/contract/add';
import recordDetail from '@/components/contract/record'
import invoiceDetail from '@/components/contract/invoice'
import {getContracInvoiceRecordList,addContractInvoiceRecord,editContractInvoiceRecord,getContracInvoiceRecordDetail,delContracInvoiceRecord} from '@/api/crmedical/contract/constractInvoiceRecord/constractInvoiceRecord';
export default {
    components:{recordDetail,invoiceDetail},
  data() {
    return {
      dialogTitle:'',
      isEdit:false,
      operateStatus:false,
      invoiceRecordsList:[],
      invoiceTypeList:[],
      addOrEditOrWatchFlag:false,//编辑新增查看的dialog
      loading:false,
      option: {
        // selection: true,reserveSelection:true,
        index: true,
        page: true,
        align: 'center',
        menuAlign: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border:true,
        height:'600',
        dialogClickModal: false,
        column: [
          {
            label: '项目名称',
            prop: 'projectName',
          },
          {
            label: '合同编号',
            prop: 'code',
          },
          {
            label: '合同名称',
            prop: 'name',
          },

          {
            label: '供应商名称',
            prop: 'partnerName',
          },
          {
            label: '发票日期',
            prop: 'invoiceTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
          {
            label: '发票类型',
            prop: 'type',
            type: 'select',
              dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl:
              '/api/blade-system/dict/dictionary?code=invoice_type'

          },
          {
            label: '发票号码',
            prop: 'invoiceNo',
          },
          {
            label: '开票金额',
            prop: 'amount',

            slot: true,
          },

        ],
      },
      query: {
        payAmountStart:'',
        payAmountEnd:'',
        timeRange:[]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
      projectList: [], //部门list
      invoiceRecordDetail:{},
      selectIds:[]
    };
  },
  created() {
    getProjectList().then((res) => {
      this.projectList = res.data;
      if (this.projectList.length > 0) {
        this.$set(this.query, 'projectId', this.projectList[0].id);

      }
      this.init()
    });
  },
  methods: {
    dialogClose(){
      this.addOrEditOrWatchFlag = false
    },
    searchClear(){
      this.query = {
         payAmountStart:'',
          payAmountEnd:'',
          timeRange:[]
      }
       this.$set(this.query, 'projectId', this.projectList[0].id);
    },
    handleClose(){
      this.invoiceRecordDetail = {}
      this.addOrEditOrWatchFlag = false
    },
    sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
    currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
    //编辑
    editInvoiceRecord(row){
      this.dialogTitle = '编辑发票记录'
      this.operateStatus = true
       this.addOrEditOrWatchFlag = true
       this.isEdit = true
       getContracInvoiceRecordDetail(row.id).then(({data})=>{
         this.invoiceRecordDetail = data
         this.invoiceRecordDetail.type = this.invoiceRecordDetail.type+''
         this.invoiceRecordDetail.name = row.name
         this.invoiceRecordDetail.code = row.code
         this.invoiceRecordDetail.partnerName = row.partnerName
        //  this.invoiceRecordDetail.id = row.id
         this.invoiceRecordDetail.taxNo = row.taxNo
         paymentrecordImg({mainId:row.id}).then(({data})=>{
          this.invoiceRecordDetail.attachList = data

        })
       })
    },
    delConstractInvoice(){
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

              let ids = this.selectIds.toString()
             delContracInvoiceRecord(ids).then(()=>{
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onLoad()
          })
        })
    },
    selectionChange(val){
      this.selectIds = []
      val.forEach(element => {
        this.selectIds.push(element.id)
      });
    },
     removeInvoiceRecord(id){
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


             delContracInvoiceRecord(id).then(()=>{
              this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.onLoad()
          })
        })
    },
    //查看
    checkInvoiceRecord(row){
      this.dialogTitle = '查看发票记录'
      this.operateStatus = false
       this.addOrEditOrWatchFlag = true
       getContracInvoiceRecordDetail(row.id).then(({data})=>{
         this.invoiceRecordDetail = data
         this.invoiceRecordDetail.type = this.invoiceRecordDetail.type+''
         this.invoiceRecordDetail.name = row.name
         this.invoiceRecordDetail.code = row.code
         this.invoiceRecordDetail.partnerName = row.partnerName
         this.invoiceRecordDetail.id = row.contractId
         this.invoiceRecordDetail.taxNo = row.taxNo
         paymentrecordImg({mainId:row.id}).then(({data})=>{
         this.invoiceRecordDetail.attachList = data

        })
       })
    },
    //获取对话框传来的数据进行操作
    getInvoiceDetail(val){
      if(this.isEdit){
        this.isEdit = false
        editContractInvoiceRecord(val).then(()=>{
           this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.addOrEditOrWatchFlag = false
            this.onLoad()
        })
        return
      }else{
        addContractInvoiceRecord(val).then(()=>{
           this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.addOrEditOrWatchFlag = false
            this.onLoad()
        })
      }
    },
    //新增
    addConstractInvoice(){
      this.invoiceRecordDetail = {
        attachList:[]
      }
      this.dialogTitle = '新增发票记录'
        this.$nextTick(()=>{
        this.operateStatus = true
        this.addOrEditOrWatchFlag = true
      })
    },
    //搜索
    searchInvoiceRecordsList(){

       let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
        if ((this.query.payAmountStart==''&&this.query.payAmountEnd=='')||(reg.test(this.query.payAmountStart)&&reg.test(this.query.payAmountEnd))) {
          if(this.query.payAmountStart>this.query.payAmountEnd){
            //大金额在后面
            let transfromNum = this.query.payAmountEnd
            this.query.payAmountEnd = this.query.payAmountStart
            this.query.payAmountStart = transfromNum
          }
          if(this.query.timeRange&&this.query.timeRange.length>0){
            this.query.timeStart = this.query.timeRange[0]
            this.query.timeEnd = this.query.timeRange[1]
          }else{
            this.query.timeRange = []
             this.query.timeStart = ''
              this.query.timeEnd = ''
          }
         this.page.currentPage = 1
          this.onLoad()
        } else {
         let sum = Number(this.query.payAmountStart)  + Number(this.query.payAmountEnd)
         if(sum == this.query.payAmountStart||sum == this.query.payAmountEnd){
           this.$message.error('请输入一个金额范围');
         }else{
           this.$message.error('金额格式不正确，请输入小数点前9位，后2位');
         }

        }
    },

    //提交信息
    submitInfo(val){
        this.addOrEditOrWatchFlag = false
        console.log('提交信息',val)
    },
    init(){
      // 发票类型字典
        getDictData({ code: 'invoice_type' }).then((res) => {

        this.invoiceTypeList = res.data;
        console.log(res.data)
        this.onLoad()
        });
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
       getContracInvoiceRecordList(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }, this.query)).then(({data})=>{
          this.invoiceRecordsList = data.records
          this.page.total = data.total
          this.loading = false;
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.boardList {
}
.form {
  display: flex;
}
.btnArea{
    width: 128px;
    float: right;
    margin-right: 56px;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
</style>
